import React, { useState, useContext } from 'react';
import ChatContext from './ChatContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HeaderScreen from "./HeaderScreen";
import MessageInputSection from "./MessageInputSection";
import vector from '../../images/Vector.svg';
import flash from '../../images/flash.svg';
import './HomeScreen.scss'; 

const HomeScreen = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [selectedKey, setSelectedKey] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileuploading, setfileuploading] = useState(false);
    const [fileuploaded, setfileuploaded] = useState(false);
    const { setInitialMessage } = useContext(ChatContext);
    


    const dictionary = {
        1: 'Implement a Centralized Knowledge Repository',
        2: 'Promote Knowledge Sharing and Collaboration',
        3: 'Utilize Technology for Data Analysis and Decision Support',
        4: 'Establish Knowledge Capture Processes'
      };

      const handleSendButtonClick = () => {
        if (message.trim() !== '') {
          //navigate('/chat', { state: { message } });
          setInitialMessage(message);
          navigate('/chat'); 
        }
      };
    
      const handleFileChange = async (e) => {
        const selectedFiles_var = Array.from(e.target.files);
        setSelectedFiles(selectedFiles_var);
        await handleUpload(selectedFiles_var);
        // setfileuploaded(true);
      };

      const handleUpload = async (selectedFiles_var) => {
        if (selectedFiles_var) {
          try {
            const formData = new FormData();
            selectedFiles_var.forEach((file, index) => {
              console.log(index)
              formData.append(`file`, file);
            });
            console.log(selectedFiles_var);
            setfileuploading(true);
            const response = await axios.post('https://industrygenai.accenture.com/tradingbe/uploadFiles', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            console.log('API response:', response.data);
            // const upload_response = response.data;
            // seUploadresponse(upload_response);
            setfileuploading(false);
            if (response.data === "file loaded successfully") {
              console.log('File uploaded successfully!')
              setfileuploaded(true);
              setTimeout(() => {
                setfileuploaded(false);
            }, 2000);
            } else {
              console.error('File upload failed.');
              alert('File upload failed.');
            }
          }
          catch (error) {
            console.log(error)
          }
        } else {
          alert('Please select a file to upload.');
        }
      };


  return (
    <div className="home-screen">
        <HeaderScreen />
        <div className="header-section">
                <div className="gradient-text">Oil & Gas Trading</div>
                <div className="gradient-text">Knowledge Management</div>
                <div className="description">
                    Optimize oil & gas trading strategies with efficient knowledge
                    management
                </div>
        </div>
        <MessageInputSection
        message={message}
        setMessage={setMessage}
        handleFileChange={handleFileChange}
        handleSendButtonClick={handleSendButtonClick}
      />
      
      <div className="ask-text">You may ask</div>
      <div className="box_qest">
        {Object.entries(dictionary).map(([key, value]) => (
          <div
            key={key}
            className={`box-home ${selectedKey === key ? 'selected' : ''}`}
            onClick={() => setSelectedKey(key)}
          >
            <img className="vector-image" src={vector} alt="vector" />
            {value}
            <div className="ask-section">
              <div className="ask-this">Ask this</div>
              <img className="flash-image" src={flash} alt="flash" />
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default HomeScreen;
